import { BlockScheduleModel } from '../models/blockschedule.model';
import { ProjectModel } from '../models/project.model';

export type SkidConfigurationParts = [number, number, number, number, number, number, number];

const EMPTY_SKID_CONFIGURATION: SkidConfigurationParts = [0, 0, 0, 0, 0, 0, 0];

function toNumberOrZero(value: unknown): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function getProjectSkidConfigurationParts(project: ProjectModel | null | undefined): SkidConfigurationParts {
  if (!project) {
    return [...EMPTY_SKID_CONFIGURATION] as SkidConfigurationParts;
  }

  return [
    toNumberOrZero(project.n1),
    toNumberOrZero(project.n2),
    toNumberOrZero(project.n3),
    toNumberOrZero(project.n4),
    toNumberOrZero(project.n5),
    toNumberOrZero(project.n6),
    toNumberOrZero(project.n7)
  ];
}

export function getBlockScheduleSkidConfigurationParts(blocks: BlockScheduleModel[] | null | undefined): SkidConfigurationParts {
  const parts = [...EMPTY_SKID_CONFIGURATION] as SkidConfigurationParts;

  for (const block of blocks ?? []) {
    const value = block.skidConfiguration?.trim().toUpperCase();
    const match = value?.match(/^N([1-7])$/);
    if (!match) {
      continue;
    }

    const index = Number(match[1]) - 1;
    parts[index] += 1;
  }

  return parts;
}

export function hasAnySkidConfiguration(parts: readonly number[] | null | undefined): boolean {
  return (parts ?? []).some(value => toNumberOrZero(value) > 0);
}

export function getEffectiveSkidConfigurationParts(
  project: ProjectModel | null | undefined,
  blocks: BlockScheduleModel[] | null | undefined
): SkidConfigurationParts {
  const blockParts = getBlockScheduleSkidConfigurationParts(blocks);
  return hasAnySkidConfiguration(blockParts) ? blockParts : getProjectSkidConfigurationParts(project);
}

